import { Stack, Button } from "@mui/material"
import logo from "../../../assets/main_logo.svg";
const Header = () => {
    return (
        <Stack direction="row" justifyContent="space-between" pt={2}>
            <img style={{ width: 125 }} src={logo} alt='Inverso logo' />
            <Button
                href="https://www.linkedin.com/in/andres-montero-gamboa/"
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                color="primary"
                sx={{ display: { xs: 'none', lg: 'block' } }}
            >Who developed this platform?</Button>
        </Stack>
    );
}

export default Header;